<template>
    <v-container :fluid="$vuetify.breakpoint.md" class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col cols="12">
                <v-card>
                    <v-card-title class="d-block text-center font-weight-bold primary secondary--text pa-1" style="word-break: normal">CANJES</v-card-title>
                    <v-btn bottom color="secondary primary--text" depressed fab absolute right small @click="getData">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                    <v-card-text class="pa-4">
                        <v-data-table
                            :headers="headers"
                            :items="redemptions"
                            :loading="loading"
                            no-data-text="Sin canjes registrados"
                            :footer-props="footerProps"/>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    name: "Winners",
    data: () => ({
        loading: true,
        redemptions: [],
        headers: [
            { text: 'Fecha', value: 'created_at' },
            { text: 'Cliente', value: 'name' },
            { text: 'Nickname', value: 'nickname' },
            { text: 'Puntos', value: 'points', align: 'right' },
            { text: 'Monto', value: 'amount_usdt', align: 'right' },
            { text: 'Movimiento', value: 'wallet_movement_id', align: 'center' },
            { text: 'Estado', value: 'status', align: 'center' },
        ],
        footerProps: {
            itemsPerPageOptions: [25, 50, 100, 200]
        }
    }),
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.loading = true;
            axios.get('/api/rewards/admin').then(res => {
                const rewards = res.data.rewards || {};
                this.redemptions = rewards.redemptions || [];
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible cargar canjes.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.loading = false;
            });
        },
        errorMessage(err, fallback) {
            if (err.response && err.response.data && err.response.data.status) {
                return err.response.data.status;
            }

            return fallback;
        }
    }
}
</script>

<style scoped>

</style>
